export default __webpack_public_path__ + "static/media/inspection_dashboard_white.99f40cb5.svg";